module.exports = __webpack_public_path__ + "assets/203e97b336d3bc83c8b492a9868d5574.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-greek-300-normal.woff2
// module id = 2626
// module chunks = 121